/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';
import {
  LOGO_WIDTH,
  LOGO_HEIGHT,
  IMAGE_WIDTH,
  IMAGE_HEIGHT,
  IMAGE_MARGIN,
  ICON_DIMENSION,
} from './constants';

export const arrowBtnCss = css({
  backgroundColor: colorsPalette.transparent,
  border: 'none',
  cursor: 'pointer',
  height: ICON_DIMENSION,
  paddingBottom: 10,
  paddingTop: 10,
  width: ICON_DIMENSION,
  [MediaQueries.md]: {
    height: 28,
    paddingTop: 7,
    width: 28,
  },
});

export const buttonsContainerCss = css({
  marginRight: 3,
  [MediaQueries.lgAndUp]: {
    marginTop: 4,
  },
});

export const captionTitleCss = css(typography.effra22, {
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  color: colorsPalette.black,
  display: 'inline-block',
  '&:hover, &:visited': {
    color: colorsPalette.black,
  },
});

export const captionTitleContainerCss = css({
  height: LOGO_HEIGHT,
  marginBottom: 8,
  display: 'flex',
  alignItems: 'center',
});

export const captionWrapperCss = css({
  background: colorsPalette.white,
  padding: '8px 16px',
  position: 'relative',
  top: -45,
  width: 257,
});

export const companyLogoCss = css({
  maxWidth: LOGO_WIDTH,
  maxHeight: '100%',
});

export const imageCss = css({
  height: IMAGE_HEIGHT,
  width: IMAGE_WIDTH,
});

export const itemCaptionCss = css(typography.effra16, {
  color: colorsPalette.grey60,
  textDecoration: 'none',
  '&:hover, &:visited': {
    color: colorsPalette.grey60,
  },
});

export const itemContainerCss = css({
  display: 'inline-block',
  marginRight: IMAGE_MARGIN,
  position: 'relative',
});

export const itemsWrapperCss = css({
  overflow: 'hidden',
});

export const leftArrowBtnCss = css({
  [MediaQueries.lgAndUp]: {
    paddingRight: 13,
  },
});

export const linkCss = css({
  textDecoration: 'none',
  ':focus': {
    display: 'inline-block',
    margin: -1,
  },
});

export const rightArrowBtnCss = css({
  [MediaQueries.lgAndUp]: {
    paddingLeft: 13,
  },
});

export const titleCss = css(typography.effra18, {
  display: 'inline-block',
  paddingBottom: 24,
});

export const titleContainerCss = css({
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 40,
});
